import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  overflow: hidden;
  height: calc(100%);
`;

export const Individual = styled.div`
  margin: 1.5rem;
  margin-bottom: 0;
`;
